import React, { memo, useCallback, useMemo } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import pathnames from "routes/pathnames";

import formatLastUpdate from "common/format-last-update";
import formatIndexNumber from "common/format-index-number";

import CONSTANTS from "constants/constant";
import { statusOptions } from "constants/status-options";

import ArticlesTableProps from "dto/components/pages/articles/page-articles-table-dto";

import AppPagination from "components/app-pagination";

import editIcon from "assets/images/components/app-articles-table/edit-icon.svg";

const ArticlesTable: React.FC<ArticlesTableProps> = ({ articles, currentPage, totalPages, fetching, onPageChange }) => {
	const navigate = useNavigate();
	const isEmptyData = useMemo(() => articles.length === 0 && !fetching, [articles.length, fetching]);

	//prettier-ignore
	const onHandleEdit = useCallback((id: string) => {
        navigate(pathnames.article + id);
    }, [navigate]);

	const getLabel = (options: { label: string; value: string }[], value: string) => {
		return options.find((option) => option.value === value)?.label || value;
	};

	return (
		<div className="app-articles-table">
			<div className="articles-table">
				<div className="articles-table__wrapper">
					<table className="articles-table__container">
						<thead className="articles-table__header">
							<tr>
								<th className="articles-table__th">No.</th>

								<th className="articles-table__th">Title</th>

								<th className="articles-table__th">Category</th>

								<th className="articles-table__th">Publication Date</th>

								<th className="articles-table__th">Status</th>

								<th className="articles-table__th">Last Update</th>
							</tr>
						</thead>

						<tbody className="articles-table__content">
							{!isEmptyData &&
								articles.map((article, index) => (
									<tr className="articles-table__tr" key={article.id}>
										<td className="articles-table__td">{formatIndexNumber(index + 1 + 10 * currentPage)}</td>

										<td className="articles-table__td">{article.title}</td>

										<td className="articles-table__td">{article.category}</td>

										<td className="articles-table__td">{moment(article.publicationDate).format(CONSTANTS.LISTING_DATE_FORMAT)}</td>

										<td className={article.status === "active" ? "articles-table__td--active" : "articles-table__td--inactive"}>{getLabel(statusOptions, article.status)}</td>

										<td className="articles-table__td">{formatLastUpdate(article.updatedAt)}</td>

										<td className="articles-table__td">
											<button className="articles-table__edit-button" onClick={() => onHandleEdit(article.id)}>
												<img src={editIcon} alt="Edit" />
											</button>
										</td>
									</tr>
								))}

							{fetching && (
								<tr className="articles-table__tr">
									<td className="articles-table__message" colSpan={7}>
										Loading...
									</td>
								</tr>
							)}

							{isEmptyData && (
								<tr className="articles-table__tr">
									<td className="articles-table__message" colSpan={7}>
										No records found
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				{!isEmptyData && !fetching && <AppPagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />}
			</div>
		</div>
	);
};

export default memo(ArticlesTable);
